<div class="login">
  <div class="login-container">
    @if (!ssoRedirect) {
    <div class="login-card">
      <div class="login-left">
        <!-- Ajoutez des styles de dégradé ou une image en arrière-plan -->
      </div>
      <div class="login-right">
        <div class="blocTop">
          <div>
            <img src="assets/img/logo.png" alt="SynthIA Logo" class="logo" />
          </div>
          <div>
            <img src="assets/img/logo_police_bleue.png" alt="SynthIA name" class="logot" />
          </div>
        </div>
        <div class="titleCo">
          Connexion
        </div>
        <div>
          <form (ngSubmit)="login()" [formGroup]="loginForm">
            <div class="form-group">
              <input type="email" class="form-control" formControlName="email" id="email"
                placeholder="Votre adresse email professionnelle" (mouseleave)="checkForm()">
            </div>

            <div class="form-group">
              <input type="password" class="form-control" formControlName="password" id="password"
                placeholder="Votre mot de passe" (mouseleave)="checkForm()" (keyup)="checkForm()">
            </div>

            <button type="submit" class="btn-connect" [disabled]="isDisableForm">
              Me connecter
            </button>
          </form>

        </div>
        <div class="text-center lostpassword fakeLink">
          <div [routerLink]="['/lostpassword']">
            J'ai oublié mon mot de passe
          </div>
        </div>

      </div>
    </div>
    } @else if (ssoLoopBlocked) {
    <div class="login-card">
      <div class="login-left"></div>
      <div class="login-right">
        <div class="blocTop">
          <div>
            <img src="assets/img/logo.png" alt="SynthIA Logo" class="logo" />
          </div>
          <div>
            <img src="assets/img/logo_police_bleue.png" alt="SynthIA name" class="logot" />
          </div>
        </div>
        <div class="titleCo">
          Connexion
        </div>
        <p class="sso-loop-message">
          La connexion via l'annuaire externe n'a pas abouti. Réessayez, et si le problème persiste, contactez le support.
        </p>
        <button type="button" class="btn-connect" (click)="startSsoLogin()">
          Se connecter via SSO
        </button>
      </div>
    </div>
    }
  </div>
</div>